import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { APPROVAL_FLOWS_PERMISSION } from "./-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/approval-flows",
)({
  staticData: {
    breadcrumb: [
      {
        label: "Workspace - Approval flows",
        href: "/settings/workspace/approval-flows",
      },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      APPROVAL_FLOWS_PERMISSION,
      "/settings/workspace/general",
    ),
})
